// Copyright (c) 2017 Deere & Company

import Dealer from '@deere/cps-it.warranty-model-factory/lib/dealer';
import t from 'tcomb';

const SelectedDealers = t.list(Dealer, 'SelectedDealers');

export const getDefaultState = () => [];

export default SelectedDealers;



// WEBPACK FOOTER //
// ./src/reports/open-pip-programs/state/selected-dealers.js